// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__ayvY1","row":"styles_row__1vSR3"};